module.exports = __webpack_public_path__ + "static/media/icon_hot_spring.c4cb498b.svg";